module.exports = __webpack_public_path__ + "media/images/user/lp/solution/list-3d0b79767f052bdd347bee724da2b422.png";